import { print } from 'graphql';

import { getApolloRuntimeClient } from '@/shared/api';
import { resolveApiBaseUrl } from '@/shared/config';
import {
  type OrderFiscalCommandLogEntryInput,
  RecordOrderFiscalCommandLogsDocument,
} from '@shared/api/graphql/gql/graphql';
import { CLIENT_VERSION } from '@shared/app-update';

export async function recordKkmJournalEntries(
  entries: readonly OrderFiscalCommandLogEntryInput[],
  organizationId: string,
  locationId: string,
): Promise<void> {
  const result = await getApolloRuntimeClient().mutate({
    mutation: RecordOrderFiscalCommandLogsDocument,
    variables: { input: { entries: [...entries] } },
    errorPolicy: 'all',
    context: {
      // Ошибки fire-and-forget транспорта не должны показывать глобальный toast.
      suppressGlobalErrorHandling: true,
      // Буфер может пережить tenant transition. Убираем актуальные tenant headers
      // из общего authLink и фиксируем исходный scope в URI батча.
      omitTenantHeaders: true,
      uri: kkmJournalGraphqlUrl(organizationId, locationId),
    },
  });

  if (result.errors?.length || result.data?.recordOrderFiscalCommandLogs !== true) {
    throw new Error('KKM journal batch was not accepted');
  }
}

export function beaconKkmJournalEntries(
  entries: readonly OrderFiscalCommandLogEntryInput[],
  organizationId: string,
  locationId: string,
  sendBeacon: Navigator['sendBeacon'] = navigator.sendBeacon.bind(navigator),
): boolean {
  const body = new Blob(
    [
      JSON.stringify({
        query: print(RecordOrderFiscalCommandLogsDocument),
        variables: { input: { entries } },
      }),
    ],
    { type: 'application/json' },
  );

  return sendBeacon(kkmJournalGraphqlUrl(organizationId, locationId), body);
}

function kkmJournalGraphqlUrl(organizationId: string, locationId: string): string {
  const origin = typeof window === 'undefined' ? 'http://localhost' : window.location.origin;
  const url = new URL(`${resolveApiBaseUrl()}/graphql`, origin);
  url.searchParams.set('client_version', String(CLIENT_VERSION));
  url.searchParams.set('organization_id', organizationId);
  url.searchParams.set('location_id', locationId);

  return url.toString();
}
